<template>
  <div class="mutil-question-wrapper">
    <base-question :is-detail="isDetail" :index="index" :question-data="questionData">
      <mutil-type :is-detail="isDetail" :question-data="questionData" />
      <div v-for="(child, key) in childAnswerList" :key="key" class="relation-wrapper">
        <div v-if="isFilled(child)">
          <div v-if="child.optionType === 3" class="upload-wrapper">
            <upload-type
              :is-detail="isDetail"
              :value="child"
              :risk-pic="riskPic"
              @input="(val) => changeData(val, child)"
              @uploading="(val) => uploading(val, child)" />
          </div>
          <div v-else class="fill-wrapper">
            <fill-type
              :is-detail="isDetail"
              :value="child" />
          </div>
        </div>
      </div>
    </base-question>
  </div>
</template>

<script>
import BaseQuestion from './base.vue'
import mutilType from '../types/mutilType.vue'
import FillType from '../types/fillType.vue'
import UploadType from '../types/uploadType.vue'

export default {
  name: 'MutilQuestion',
  props: {
    questionData: {
      type: Object,
      default: ()=>{}
    },
    value: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    riskPic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseQuestion,
    mutilType,
    FillType,
    UploadType
  },
  data() {
    return {
    };
  },
  computed: {
    chosenAnswerList() {
      return this.questionData.memberAnswerList.filter(item => item.memberOptionSelected === 1);
    },
    childAnswerList() {
      const list = []
      this.chosenAnswerList?.map(item => {
        if (item?.childAnswerList?.length) {
          list.push(...item.childAnswerList);
        }
      });
      return list;
    }
  },
  methods: {
    isFilled(child) {
      if (this.isDetail) {
        return child.memberAnswerPicList?.length > 0 || child.memberOptionContent;
      } else {
        return true;
      }
    },
    changeData(val, child) {
      this.$set(child, 'memberAnswerPicList', val?.memberAnswerPicList || []);
    },
    uploading(val) {
      this.$emit('uploading', val);
    },
  }
}
</script>

<style lang="scss" scoped>
.mutil-question-wrapper {
  margin-top: 12px;
}
.relation-wrapper {
  .upload-wrapper, .fill-wrapper {
    margin-top: 32px;
  }
}
</style>
